import ParentTreeFragment from '@/lib/fragments/parent-tree/simple'
import { graphql } from '@/lib/query'

const CheckboxFieldFragment = graphql(
  /* GraphQL */ `
    fragment CheckboxFieldFragment on FormFieldCheckboxRecord @_unmask {
      _modelApiKey
      __typename
      id
      required
      halfSize
      label
      checked
      infoLink {
        id
        slug
        pageTitle
        _modelApiKey
        ...ParentTreeFragment
      }
      fieldId
    }
  `,
  [ParentTreeFragment]
)

export default CheckboxFieldFragment
